import { useMutation } from '../';
import { newQuicksightDashboard } from '../mutations';

export function useNewQuicksightDashboard() {
  const { data, isLoading, mutate } = useMutation();
  
  const run = (variables, onFinish) => {
    mutate(newQuicksightDashboard, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newQuicksightDashboard.id);
      }
    });
  };

  return { data, isLoading, run };
}
